import React from 'react';
import PropTypes from 'prop-types';
import { List, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import useUserContext from 'Context/UserContext';
import { AGENT_ROLE } from 'Consts/Role';
import NotificationListItem from './NotificationListItem';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  rootFooter: {
    paddingBottom: 0,
  },
  item: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.facet.lightGray,
  },
  read: {
    backgroundColor: 'inherit',
  },
  expanded: {
    padding: theme.spacing(1),
  },
}));

export default function NotificationList({
  updateNotification,
  expand,
  notifications,
  footer,
  ...rest
}) {
  const classes = useStyles();
  const userCtx = useUserContext();
  const { userResource } = userCtx;

  const handleNotificationView = notification => Promise.all(
    [
      notification.id,
      ...(notification.related || []).map(n => n.id),
    ].map(id => updateNotification(id)),
  );

  return (
    <List
      test={'header-notification-list'}
      classes={{
        root: classNames(classes.root, {
          [classes.rootFooter]: !!footer,
        }),
      }}
      disablePadding={!expand}
      {...rest}
    >
      {notifications.map(n => (
        <NotificationListItem
          key={n.id}
          className={classNames(classes.item, {
            [classes.read]: Boolean(n.viewedOn),
          })}
          onClick={() => handleNotificationView(n)}
          notification={n}
          isAgent={
            userResource && userResource.attr('userTypes').includes(AGENT_ROLE)
          }
        />
      ))}
      {footer}
    </List>
  );
}

NotificationList.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateNotification: PropTypes.func.isRequired,
  expand: PropTypes.bool,
  footer: PropTypes.node,
};

NotificationList.defaultProps = {
  expand: false,
  footer: null,
};
